// =============================================================================
// src/views/cinema/index.ts — AppModule do Modo Cinema (Tela 02 · animacao historica).
//
// Proveniencia: Sections.cinema (assets/unified-app.js 2119-2374) +
//   cinemaYears/cinemaMarkerPositions (DATA). Diferente das outras telas, o
//   Modo Cinema NAO tem markup estatico em unified.html: o overlay (year-display,
//   timeline, stats, controles) e gerado em runtime dentro de #mapOverlays e a
//   tela e acionada por TopbarNav.go('cinema') -> SectionManager.activateSection
//   ('cinema'). Por isso render() devolve string vazia (nada a montar em
//   #routeLayer/#contentCol) e init() e no-op: o ciclo de vida real ocorre em
//   activate(ctx)/deactivate(), despachados pela SectionManager (scroll-spy).
//
// O comportamento (overlay, play, ghost, exit) vive em CinemaSectionController;
//   aqui so adaptamos o contrato AppModule -> controller (mapa via ctx.map).
// =============================================================================

import type { AppContext } from '../../app/types';
import type { SectionLifecycleModule } from '../../core/section-manager';
import { CinemaSectionController } from './cinema-controller';

/** Instancia unica do controlador do cinema (estado de ano/play/ghost persiste). */
const cinemaController = new CinemaSectionController();

/**
 * AppModule do Modo Cinema. render() vazio (overlay gerado em runtime); init()
 * no-op; activate/deactivate delegam ao CinemaSectionController quando a secao
 * 'cinema' entra/sai pelo scroll-spy ou por TopbarNav.go('cinema').
 */
export const cinemaView: SectionLifecycleModule = {
  id: 'cinema',
  render(): string {
    return '';
  },
  init(): void {
    // Sem listeners no init: o ciclo de vida real ocorre em activate/deactivate.
  },
  activate(ctx: AppContext): void {
    if (ctx.map) cinemaController.activate(ctx.map);
  },
  deactivate(): void {
    cinemaController.deactivate();
  },
};

export default cinemaView;
